import React from "react";
import { Icon } from "rhombus-react";
import { capFirst, safeDecodeURIComponent } from "utils/common";
import { buildAssetId, isVideoAsset } from "utils/Assets";
import { useShiftClick } from "hooks/useShiftClick";

import { useDispatch } from "react-redux";
import { toggleSelectedItem } from "reducers/Selected";

import "./AssetName.css";

const EVENT_RIGHT_CLICK_PRESS = 2;

export function AssetName(props){
	let { assetId, assetType, encoded, type, isSelected } = props.dependentValues;
	const dispatch = useDispatch();

	let iconName = `asset${capFirst(assetType)}`;
	const shiftClick = useShiftClick(assetId, type, { buildItemId: buildAssetId });
	const displayName = safeDecodeURIComponent(props.value);

	// [HOPI-1737] Manually assign icon for encoded video since it isn't asssigned in rhombus
	if(isVideoAsset(assetType) && !encoded) {
		iconName = "far fa-video";
	}
	// TODO: Remove once rhombus 2.8.2 is is use
	if("AfterEffects" === assetType){
		iconName = "fas fa-file-zipper";
	}

	if (assetType === "ImposiumProject") {
		iconName = "fa fa-paintbrush-pencil";
	}

	const handleClick = (event) => {
		// Prevent selection with right click
		if (event.button === EVENT_RIGHT_CLICK_PRESS) {
			return;
		}

		if (event.nativeEvent.shiftKey) {
			shiftClick(event);
			return;
		}
		dispatch(toggleSelectedItem(assetId, type, !isSelected));
	};

	return (
		<label htmlFor={assetId} onMouseDown={handleClick}>
			<div className={`asset-name-col asset-type-${assetType?.toLowerCase()}`} >
				<Icon name={iconName} title={assetType} />
				<span className="asset-name name-overflow" title={displayName}>{displayName}</span>
			</div>
		</label>
	);
}

const AssetNameCell = {
	key: "name",
	name: "Asset Name",
	cellClass: "asset-name-cell fill-cell",
	formatter:AssetName,
	getRowMetaData(data){
		return {
			id:data.id,
			assetType:data.assetType,
			assetId:data.assetId,
			encoded:data.encoded,
			isSelected:data.isSelected,
			type: "assets",
		};
	},
	sortable: true,
	resizable:true,
};

export default AssetNameCell;
